import { Observable, Subject } from 'rxjs';
import { AlertColor } from '@mui/material';
import { useCallback } from 'react';

export type NotificationPayload = {
  type: AlertColor;
  message: string;
};

let notificationSubject: Subject<NotificationPayload> | null = null;

const getNotificationSubject = () => {
  if (!notificationSubject) {
    notificationSubject = new Subject<NotificationPayload>();
  }
  return notificationSubject;
};

export const useNotifications = () => {
  const subject = getNotificationSubject();

  const getNotification$ = useCallback((): Observable<NotificationPayload> => {
    return subject.asObservable();
  }, [subject]);

  const notify = useCallback(
    (payload: NotificationPayload) => {
      subject.next(payload);
    },
    [subject]
  );

  return { notify, getNotification$ };
};
